// extracted by mini-css-extract-plugin
export default {"content":"AppShell_content__88eNl"};